import React from "react";

export const Services = (props) => {
  const data = props.data;
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{data ? data.title : "What I Do"}</h2>
          <p>{data ? data.subtitle : ""}</p>
        </div>
        <div className="row">
          {data && data.items
            ? data.items.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="service-card">
                    <i className={d.icon}></i>
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
